import { useEstimationsForm } from './Dialog.h'

import MotionDialog from '@shared/components/MotionDialog'
import Fields from './parts/fields/Fields'
import Cropper from './parts/Cropper'
import Docs from './parts/documents/Docs'
import { FormProvider } from 'react-hook-form'
import 'cropperjs/dist/cropper.css'

export default function EstimationForm({instance}) {
    const context = useEstimationsForm(instance)

    return (
        <FormProvider {...context.form}>
            <MotionDialog
                onClose={context.handleClose}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: context.handleSave,
                        sx: {height: '100%'}
                    }
                }}
                context={context}
            >
                <Fields />
                {context.dialogMode == 'cropper' && <Cropper />}
                {context.dialogMode == 'docs' && <Docs />}
            </MotionDialog>
        </FormProvider>
    )
}